import React from 'react'
import styled, { css } from 'styled-components'

// Components
import { Item } from '../../../components/SelectDropdown'
import { SignedOutLabel as SignedOutLabelOriginal } from 'modules/workspace/containers/WorkspacesDropdown'
import {
  WorkspaceLogo as BaseWorkspaceLogo,
  LoadingPlaceholder,
} from '@sketch/components'

// Icons
import { ReactComponent as ExclamationMark } from '@sketch/icons/exclamation-mark-16-svg'
import { ReactComponent as ChevronRight } from '@sketch/icons/chevron-right-16-svg'

export const Chevron = styled(ChevronRight)`
  width: 16px;
  margin: 0 12px 0 auto;
  opacity: 0.55;
`

export const WorkspaceLogo = styled(BaseWorkspaceLogo)`
  margin-right: 12px;
  opacity: 1;
`

export const WorkspacesItem = styled(Item)`
  && {
    /* Increase the specificity of the height related to the "Item" */
    height: 40px;
  }

  /* This is needed to make the dropdown container always visible even when the button is just a since pixel on */
  & ~ [aria-haspopup='true'] {
    position: sticky;
    top: 0;
    bottom: 0;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
      pointer-events: none;
    `}
`

export const SignedOutLabel = styled(SignedOutLabelOriginal)`
  flex: 1 0 auto;
`

const ErrorItem = styled(Item)`
  color: ${({ theme }) => theme.colors.state.negative.A};
`

const ErrorIcon = styled(ExclamationMark)`
  color: ${({ theme }) => theme.colors.state.negative.A};
  opacity: 1;
`

export function LoadingState() {
  return (
    <Item
      text="Loading projects…"
      icon={({ className }) => (
        <LoadingPlaceholder className={className} size="16px" />
      )}
      disabled
    />
  )
}

export function ErrorState() {
  return (
    <ErrorItem
      text="Unable to load"
      icon={({ className }) => <ErrorIcon className={className} />}
      disabled
    />
  )
}
